<script setup>
import { BModal,BButton} from "bootstrap-vue-next";
import DataTable from '@/components/DataTable.vue';
import { ref, defineProps, defineModel } from 'vue';

const modal = defineModel()
const props = defineProps({
    data : Array,
    title : String,
    
})
const header=[
    {key : 'pax', label : 'Total Pax', class : 'text-center' },
    {key : 'price', label : 'Price', class : 'text-center' },
    {key : 'action', label : 'Action', class : 'text-center' },
]

const customActions = ref([
    {
        label: 'Edit',
        variant: 'success',
        icon: 'fas fa-edit',
        action: (item) => {
        console.log('Edit action clicked for:', item);
        // Implement your edit logic here
        }
    },
    {
        label: 'Delete',
        variant: 'danger',
        icon: 'fas fa-trash',
        action: (item) => {
        console.log('Delete action clicked for:', item);
        // Implement your delete logic here
        }
    },
    
]);
</script>

<template>
    <BModal :title="props.title" size="xl" v-model="modal" scrollable centered>
        <BButton variant="primary">+ Add New</BButton>
        <DataTable :data="props.data" :header="header" :custom-actions="customActions"></DataTable>
    </BModal>
</template>